import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Field } from "redux-form";
import toast from "react-hot-toast";
import { verifyPasscode, updatedProtected } from "@registrationaction";
import { renderFieldText } from "@basecomponent";
import { classNames } from "@utilscommon";
import LocaleStrings from "@language";
import {
  proposalVerifyEmail,
  verifyProposalPasscode,
  updatedProposalProtected,
  fetchProposalData,
} from "@proposalaction";

const ProtectedPage = (props) => {
  let {
    session,
    checkoutFormData,
    handleSubmit,
    pristine,
    invalid,
    submitting,
    callFrom,
    proposalData,
  } = props;
  const [loading, setLoading] = useState(false);
  let isPasswordScreen =
    callFrom == "proposal" ? proposalData.submitteddata.email_code_exist : "";

  const onSubmitForm = (data) => {
    let values = {
      ...data,
      formid: checkoutFormData?.data?.formid,
      eventid: checkoutFormData?.data?.eventid,
    };
    // console.log("Final values :- ", values);

    setLoading(true);
    if (callFrom !== "proposal") {
      props.verifyPasscode(session, values, (response) => {
        setLoading(false);
        if (response.success === 1) {
          // Ok
        } else if (response.success === 2) {
          toast.error(LocaleStrings.kInvalidPasscode);
        } else {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        }
      });
    } else {
      if (isPasswordScreen) {
        let sendData = {};
        sendData.responseid = proposalData?.submitteddata?.id;
        sendData.passcode = data.passcode;
        sendData.eventid = session.eventid;
        props.verifyProposalPasscode(session, sendData, (response) => {
          setLoading(false);
          if (response.data.success === 1) {
            props.updatedProposalProtected(false);
            toast.success(LocaleStrings.kPassCodeSendSuccess);

            // Ok
          } else if (response.data.success === 0) {
            toast.error(LocaleStrings.kPassCodeError);
          } else {
            toast.error(LocaleStrings.kSomethingWentWrongMsg);
          }
        });
      } else {
        let sendData = {};
        sendData.responseid = proposalData?.submitteddata?.id;
        sendData.email = data.verifyemail;
        sendData.eventid = session.eventid;
        props.proposalVerifyEmail(session, sendData, (response) => {
          if (response.data.success === 1) {
            let data = { eventid: session?.eventid };
            data.proposalid = proposalData?.proposaldata?.proposalid;
            data.responseid = proposalData?.submitteddata?.id;

            props.fetchProposalData(session, data, () => {
              setLoading(false);
              toast.success(LocaleStrings.kEmailSendSuccess);
            });

            // Ok
          } else if (response.data.success === 0) {
            setLoading(false);

            toast.error(LocaleStrings.kEmailError);
          } else {
            setLoading(false);

            toast.error(LocaleStrings.kSomethingWentWrongMsg);
          }
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <div className="text-center text-2xl font-bold text-primary">
        {callFrom == "proposal"
          ? isPasswordScreen
            ? LocaleStrings.kVerifyPasscodeText
            : LocaleStrings.kVerifyEmail
          : LocaleStrings.kVerifyPasscodeText}
      </div>
      <p
        className={`custom-text-secondary-sm-medium my-6 ${
          callFrom == "proposal" ? "text-center" : ""
        }`}
      >
        {callFrom == "proposal"
          ? isPasswordScreen
            ? LocaleStrings.kVerifyEmailInfoText
            : LocaleStrings.kVerifyProposalCodeInfoText
          : LocaleStrings.kVerifyPasscodeInfoText}
      </p>

      <div className={classNames("base-form max-w-xl m-auto")}>
        {callFrom !== "proposal" ? (
          <Field
            name="passcode"
            label={LocaleStrings.kLabelPasscode}
            placeholder={LocaleStrings.kEnterPasscodeText}
            type="password"
            component={renderFieldText}
            mandatory={true}
          />
        ) : isPasswordScreen ? (
          <Field
            name="passcode"
            label={LocaleStrings.kLabelPasscode}
            placeholder={LocaleStrings.kEnterPasscodeText}
            type="password"
            component={renderFieldText}
            mandatory={true}
          />
        ) : (
          <Field
            name="verifyemail"
            label={LocaleStrings.kEmail}
            placeholder={LocaleStrings.kEnterEmailAddress}
            type="email"
            component={renderFieldText}
            mandatory={true}
          />
        )}

        <div className="text-right">
          <button
            type="submit"
            className="theme-button-md"
            disabled={pristine || invalid || submitting || loading}
          >
            <svg
              className={classNames(
                loading ? "" : "hidden",
                "cust-btn-spinner"
              )}
              viewBox="0 0 1024 1024"
              focusable="false"
              data-icon="btnloading"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
            </svg>{" "}
            {callFrom !== "proposal"
              ? LocaleStrings.kVerifyPasscodeText
              : isPasswordScreen
              ? LocaleStrings.kVerifyPasscodeText
              : LocaleStrings.kVerifyEmail}
          </button>
        </div>
      </div>
    </form>
  );
};
const mapStateToProps = (state) => {
  return {
    session: state.session,
    checkoutFormData: state.checkoutFormData,
    proposalData: state?.proposalData?.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      verifyPasscode,
      updatedProtected,
      proposalVerifyEmail,
      verifyProposalPasscode,
      updatedProposalProtected,
      fetchProposalData,
    },
    dispatch
  );
};

function validate(values) {
  // console.log("values :- ", values);
  let errors = {};
  let passcode = values.passcode;

  if (!passcode || passcode.trim() === "") {
    errors["passcode"] = LocaleStrings.kFieldRequired;
  }

  // console.log("errors :- ", errors);
  return errors;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "ProtectedForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ProtectedPage)
);
